export type DefaultResponse = {
  success: boolean;
  message?: string;
  error?: {
    code: number;
    message: string;
    removeUser?: boolean;
  };
  content?: any;
};

type ApiSuccessResponse<T> = {
  success: true;
  content: T;
  message?: string;
};

export type ApiErrorResponse = {
  success: false;
  error: {
    code: number;
    message: string;
    removeUser?: boolean;
  };
  message?: string;
};

export type ApiResponse<T> = ApiSuccessResponse<T> | ApiErrorResponse;

export const isApiSuccess = <T>(
  response: ApiResponse<T>
): response is ApiSuccessResponse<T> => {
  return response.success === true;
};

export type DecodedToken = {
  role: string;
  email: 'admin' | 'golfer';
};

type PaginatedContent<T> = {
  data: T[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
};

export type PaginatedApiResponse<T> = ApiResponse<PaginatedContent<T>>;

export const FileTypes = {
  IMAGE: 'image',
  VIDEO: 'video',
  PDF: 'pdf',
} as const;

export type FileType = (typeof FileTypes)[keyof typeof FileTypes];

export type MediaFile = {
  id: string;
  url: string;
  type: FileType;
  name?: string;
};
